(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["holistic-campaign-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const timers = new WeakMap();

    const update = (element) => {
      const end = new Date(element.dataset.end).getTime();
      const remaining = Math.max(0, end - Date.now());
      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);

      element.querySelector('[data-days]').textContent = String(days).padStart(2, '0');
      element.querySelector('[data-hours]').textContent = String(hours).padStart(2, '0');
      element.querySelector('[data-minutes]').textContent = String(minutes).padStart(2, '0');
      element.querySelector('[data-seconds]').textContent = String(seconds).padStart(2, '0');

      if (remaining === 0) {
        const campaign = element.closest('.hc-campaign');
        const grid = element.querySelector('.hc-campaign__countdown-grid');
        const title = element.querySelector('.hc-campaign__countdown-title');
        const lead = campaign && campaign.querySelector('.hc-campaign__lead');
        const catalogTitle = campaign && campaign.querySelector('.hc-campaign__catalog-intro h2');

        if (campaign) campaign.classList.add('hc-campaign--ended');
        if (grid) grid.hidden = true;
        if (title) title.textContent = element.dataset.endedLabel;
        if (lead && campaign.dataset.endedIntro) lead.textContent = campaign.dataset.endedIntro;
        if (catalogTitle) catalogTitle.textContent = 'Oglejte si izdelke';
        element.setAttribute('aria-label', element.dataset.endedLabel);
        window.clearInterval(timers.get(element));
        return false;
      } else {
        element.setAttribute('aria-label', `${days} dni, ${hours} ur, ${minutes} minut in ${seconds} sekund do konca akcije`);
        return true;
      }
    };

    const init = (root = document) => {
      root.querySelectorAll('[data-hc-campaign-countdown]').forEach((element) => {
        window.clearInterval(timers.get(element));
        if (update(element)) {
          timers.set(element, window.setInterval(() => update(element), 1000));
        }
      });
    };

    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holistic-five-routines"] && !Shopify.designMode) return;
  try {
    
(function(){
  const controllers = new Map();
  function init(root){
    if(controllers.has(root.id)) controllers.get(root.id)();
    const cleanup = [];
    const active = root.dataset.active === 'true';
    const end = Date.parse(root.dataset.end);
    const timers = Array.from(root.querySelectorAll('[data-hr-timer]'));
    const deadlines = Array.from(root.querySelectorAll('[data-hr-deadline]'));
    const sticky = root.querySelector('[data-hr-sticky]');
    let expired = !Number.isFinite(end) || Date.now() >= end;
    const dateFormatter = new Intl.DateTimeFormat('sl-SI',{timeZone:'Europe/Ljubljana',day:'numeric',month:'numeric',year:'numeric',hour:'2-digit',minute:'2-digit',hour12:false});
    const endLabel = Number.isFinite(end) ? dateFormatter.format(new Date(end)) : '';
    if(active && !expired){
      deadlines.forEach(function(el){
        el.textContent = root.dataset.prefix + ' ' + endLabel + '.';
      });
    }
    function tick(){
      const left = end - Date.now();
      expired = !Number.isFinite(left) || left <= 0;
      if(!active || expired){
        timers.forEach(function(t){t.hidden=true;});
        if(active && expired){
          root.classList.add('hr-expired');
          deadlines.forEach(function(d){d.textContent=Number.isFinite(end) ? root.dataset.expiredText : 'Datum zaključka trenutno ni določen.';});
          if(sticky) sticky.hidden=true;
        }
        return;
      }
      const secs = Math.floor(left/1000);
      const units = {days:Math.floor(secs/86400),hours:Math.floor(secs/3600)%24,minutes:Math.floor(secs/60)%60,seconds:secs%60};
      timers.forEach(function(timer){
        timer.hidden=false;
        Object.keys(units).forEach(function(unit){
          const el=timer.querySelector('[data-unit="'+unit+'"]');
          if(el) el.textContent=String(units[unit]).padStart(2,'0');
        });
      });
    }
    tick();
    const interval=setInterval(tick,1000);
    cleanup.push(function(){clearInterval(interval);});
    const onVisibility=function(){if(!document.hidden)tick();};
    document.addEventListener('visibilitychange',onVisibility);
    cleanup.push(function(){document.removeEventListener('visibilitychange',onVisibility);});

    function onClick(event){
      const link=event.target.closest('a[data-hr-scroll]');
      if(!link || !root.contains(link))return;
      const target=document.getElementById(link.getAttribute('href').slice(1));
      if(!target)return;
      event.preventDefault();
      target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
      target.setAttribute('tabindex','-1');
      target.focus({preventScroll:true});
    }
    root.addEventListener('click',onClick);
    cleanup.push(function(){root.removeEventListener('click',onClick);});
    root.querySelectorAll('[data-hr-product]').forEach(function(card){
      const select=card.querySelector('[data-hr-variant]');
      if(!select)return;
      const image=card.querySelector('.hr-product-image:not([data-hr-custom-image]) img');
      const originalImage=image ? {src:image.getAttribute('src'),srcset:image.getAttribute('srcset')} : null;
      const links=Array.from(card.querySelectorAll('[data-hr-product-link]'));
      const urls=links.map(function(l){return new URL(l.href);});
      const update=function(){
        const option=select.options[select.selectedIndex];
        card.querySelector('[data-hr-price]').textContent=option.dataset.money;
        const compare=card.querySelector('[data-hr-compare]');
        compare.hidden=!option.dataset.compare;
        compare.querySelector('s').textContent=option.dataset.compare || '';
        card.querySelector('[data-hr-availability]').hidden=option.dataset.available==='true';
        links.forEach(function(link,i){const url=new URL(urls[i]);url.searchParams.set('variant',option.value);link.href=url.pathname+url.search;});
        if(image && originalImage){
          if(option.dataset.image){image.src=option.dataset.image;image.removeAttribute('srcset');}
          else{image.src=originalImage.src;if(originalImage.srcset)image.setAttribute('srcset',originalImage.srcset);}
        }
      };
      select.addEventListener('change',update);
      update();
      cleanup.push(function(){select.removeEventListener('change',update);});
    });


    root.querySelectorAll('[data-hr-cart-form]').forEach(function(form){
      const button=form.querySelector('[data-hr-cart-button]');
      const items=Array.from(form.querySelectorAll('[data-hr-cart-item]'));
      if(!items.length)return;
      const money=new Intl.NumberFormat('sl-SI',{style:'currency',currency:root.dataset.currency||'EUR'});
      let adding=false;
      function values(){
        return items.map(function(item){
          const data=item.tagName==='SELECT'?item.options[item.selectedIndex].dataset:item.dataset;
          return {productId:Number(item.closest('[data-product-id]')?.dataset.productId||0),id:item.value,price:Number(data.price),available:data.available==='true',money:data.money,compare:data.compare,comparePrice:Number(data.comparePrice)||0};
        });
      }
      function sync(){
        const current=values();
        const total=current.reduce(function(sum,item){return sum+item.price;},0);
        const packageQuote=window.HolisticRoutineDiscounts?.quote(current);
        const packageDiscount=packageQuote?.savings>0;
        form.classList.toggle('hr-discount-active',Boolean(packageDiscount));
        form.querySelector('[data-hr-total]').textContent=money.format((packageDiscount?packageQuote.total:total)/100);
        const packageRegular=form.querySelector('[data-hr-package-regular]');
        if(packageRegular){
          packageRegular.hidden=!packageDiscount;packageRegular.textContent=packageDiscount?money.format(total/100):'';
          form.querySelector('[data-hr-package-savings]').hidden=!packageDiscount;
          form.querySelector('[data-hr-package-saving-money]').textContent=packageDiscount?money.format(packageQuote.savings/100):'';
          form.querySelector('[data-hr-package-saving-percent]').textContent=packageDiscount?'−'+Math.round(packageQuote.savings*100/total)+' %':'';
          form.querySelector('[data-hr-package-condition]').hidden=!packageDiscount;
        }
        items.forEach(function(item,i){
          const row=item.closest('.hr-component-item');
          if(!row)return;
          row.querySelector('[data-hr-component-price]').textContent=money.format((packageDiscount?packageQuote.prices[i]:current[i].price)/100);
          if(packageDiscount){
            let base=row.querySelector('[data-hr-package-item-regular]');
            if(!base){base=document.createElement('s');base.className='hr-component-compare';base.setAttribute('data-hr-package-item-regular','');row.querySelector('.hr-component-line').after(base);}
            base.textContent=money.format(current[i].price/100);base.hidden=false;
          }else{const base=row.querySelector('[data-hr-package-item-regular]');if(base)base.hidden=true;}
          if(item.tagName==='SELECT'){
            let compare=row.querySelector('.hr-component-compare');
            if(current[i].compare){
              if(!compare){compare=document.createElement('s');compare.className='hr-component-compare';row.querySelector('.hr-component-line').after(compare);}
              compare.textContent=current[i].compare;compare.hidden=false;
            }else if(compare){compare.hidden=true;}
          }
        });
        const savings=form.querySelector('[data-hr-savings]');
        if(savings){
          const selected=current[0];
          const comparison=selected?.comparePrice||0;
          const reduced=Boolean(selected && comparison>selected.price);
          savings.hidden=!reduced;
          const compare=form.querySelector('[data-hr-compare]');
          compare.hidden=!reduced;
          compare.querySelector('s').textContent=reduced?money.format(comparison/100):'';
          savings.querySelector('[data-hr-saving-money]').textContent=reduced?money.format((comparison-selected.price)/100):'';
          savings.querySelector('[data-hr-saving-percent]').textContent=reduced?'('+Math.floor((comparison-selected.price)*100/comparison)+' %)':'';
        }
        const ready=current.length===Number(form.dataset.count) && current.every(function(item){return item.available && item.id;});
        if(button)button.disabled=adding || !ready;
        const unavailable=form.querySelector('[data-hr-components-unavailable]');
        if(unavailable)unavailable.hidden=ready;
      }
      items.forEach(function(item){item.addEventListener('change',sync);cleanup.push(function(){item.removeEventListener('change',sync);});});
      sync();
      document.addEventListener('holistic:routine-discounts-ready',sync);
      cleanup.push(function(){document.removeEventListener('holistic:routine-discounts-ready',sync);});
      window.HolisticRoutineDiscounts?.ready().then(sync);
      async function submit(event){
        if(!button)return;
        event.preventDefault();
        if(adding || button.disabled)return;
        adding=true;sync();
        button.setAttribute('aria-busy','true');
        const label=button.querySelector('[data-hr-button-label]');
        const original=label.textContent;
        label.textContent='DODAJAM …';
        const message=form.querySelector('[data-hr-cart-message]');
        const cartLink=form.querySelector('[data-hr-cart-link]');
        message.hidden=true;cartLink.hidden=true;
        try{
          const route=window.Shopify?.routes?.root||'/';
          const body={items:values().map(function(item){return {id:Number(item.id),quantity:1};})};
          const response=await fetch(route+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json','X-Kaching-Cart-Ignore':'1'},body:JSON.stringify(body)});
          const payload=await response.json();
          if(!response.ok || payload.status)throw new Error(payload.description||payload.message||'Izbire trenutno ni mogoče dodati. Preveri razpoložljivost izdelkov.');
          await window.HolisticRoutineDiscounts?.sync();
          message.textContent='Izdelki so dodani v košarico.';message.hidden=false;cartLink.hidden=false;
          if(!window.HolisticRapidCart?.open()){
            message.textContent='Izdelki so dodani. Košarico odpri s spodnjim gumbom. Če se ne odpre, osveži stran; izdelkov ni treba dodati ponovno.';
          }
        }catch(error){
          message.textContent=error.message||'Pri dodajanju je prišlo do napake. Poskusi ponovno.';message.hidden=false;
        }finally{
          adding=false;button.removeAttribute('aria-busy');label.textContent=original;sync();
        }
      }
      function openCart(event){
        event.preventDefault();
        if(!window.HolisticRapidCart?.open()){
          const message=form.querySelector('[data-hr-cart-message]');
          message.textContent='Košarica se trenutno ne more odpreti. Osveži stran; že dodani izdelki ostanejo v košarici.';
          message.hidden=false;
        }
      }
      const cartLink=form.querySelector('[data-hr-cart-link]');
      cartLink.addEventListener('click',openCart);
      cleanup.push(function(){cartLink.removeEventListener('click',openCart);});
      form.addEventListener('submit',submit);
      cleanup.push(function(){form.removeEventListener('submit',submit);});
    });

    if(sticky){
      const hero=root.querySelector('[data-hr-hero-cta]');
      const final=root.querySelector('[data-hr-final]');
      const choice=root.querySelector('.hr-choice');
      const faq=root.querySelector('.hr-faq');
      let frame=0;
      function visible(el){
        if(!el)return false;
        const rect=el.getBoundingClientRect();
        const style=getComputedStyle(el);
        return style.display!=='none' && style.visibility!=='hidden' && Number(style.opacity)!==0 && rect.width>0 && rect.height>0 && rect.right>0 && rect.left<innerWidth && rect.bottom>0 && rect.top<innerHeight;
      }
      function refreshSticky(){
        frame=0;
        const heroRect=hero.getBoundingClientRect();
        const finalRect=final.getBoundingClientRect();
        const blockers=document.querySelectorAll('#rapi-cart-drawer-panel,#CartDrawer,[aria-modal="true"],#shopify-pc__banner,.shopify-pc__banner,#cookie-banner,[id*="cookie-banner"],[id*="CookieBanner"]');
        const chat=document.querySelector('shopify-chat');
        const chatRoot=chat?.shadowRoot;
        const chatOpen=!!chatRoot?.querySelector('shopify-agent-runtime[open]') || chatRoot?.querySelector('.activator')?.getAttribute('aria-expanded')==='true' || Array.from(chatRoot?.querySelectorAll('iframe,[role=dialog]')||[]).some(visible);
        const blocked=Array.from(blockers).some(visible)||chatOpen;
        let offset=0;
        const floating=Array.from(document.querySelectorAll('.mobile-dock-container,#shopify-chat,#ShopifyChat'));
        const chatButton=chatRoot?.querySelector('.activator');
        if(chatButton)floating.push(chatButton);
        floating.forEach(function(el){
          if(visible(el)){const r=el.getBoundingClientRect();offset=Math.max(offset,innerHeight-r.top+8);}
        });
        sticky.style.setProperty('--hr-sticky-offset',Math.min(offset,innerHeight*.7)+'px');
        const choosing=visible(choice)||visible(faq);
        const buying=Array.from(root.querySelectorAll('[data-hr-cart-button],[data-hr-product-cta]')).some(visible);
        sticky.hidden=innerWidth>=900 || (active && expired) || blocked || choosing || buying || heroRect.bottom>0 || finalRect.top<innerHeight;
      }
      function schedule(){if(!frame)frame=requestAnimationFrame(refreshSticky);}
      addEventListener('scroll',schedule,{passive:true});
      addEventListener('resize',schedule,{passive:true});
      const observer=new MutationObserver(function(records){
        if(records.some(function(r){return !root.contains(r.target);}))schedule();
      });
      const observerOptions={attributes:true,childList:true,subtree:true,attributeFilter:['class','style','aria-hidden','aria-expanded','open']};
      observer.observe(document.body,observerOptions);
      const observedChatRoot=document.querySelector('shopify-chat')?.shadowRoot;
      if(observedChatRoot)observer.observe(observedChatRoot,observerOptions);
      schedule();
      cleanup.push(function(){removeEventListener('scroll',schedule);removeEventListener('resize',schedule);observer.disconnect();if(frame)cancelAnimationFrame(frame);});
    }
    controllers.set(root.id,function(){cleanup.forEach(function(fn){fn();});controllers.delete(root.id);});
  }
  document.querySelectorAll('[data-hr-section]').forEach(init);
  document.addEventListener('shopify:section:load',function(event){event.target.querySelectorAll('[data-hr-section]').forEach(init);});
  document.addEventListener('shopify:section:unload',function(event){event.target.querySelectorAll('[data-hr-section]').forEach(function(root){if(controllers.has(root.id))controllers.get(root.id)();});});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holistic-guide"] && !Shopify.designMode) return;
  try {
    
  (()=>{const num=v=>Number.parseFloat(String(v||'').trim().replace(',','.')),ok=v=>Number.isFinite(v)&&v>0,fmt=(v,d=2)=>new Intl.NumberFormat('sl-SI',{minimumFractionDigits:d,maximumFractionDigits:d}).format(v),esc=s=>String(s).replace(/[&<>'"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c])),get=(s,n)=>s.querySelector(`[data-field="${n}"]`),error=(f,m)=>{const e=f.querySelector('[data-error]');e.textContent=m;e.hidden=false;f.querySelector('[data-results]').hidden=true},clear=f=>{const e=f.querySelector('[data-error]');e.textContent='';e.hidden=true};document.querySelectorAll('[data-hg-root]').forEach(root=>{root.querySelectorAll('[data-fill]').forEach(b=>b.addEventListener('click',()=>{const target=root.querySelector(`[data-product="${b.dataset.fill}"]`);if(!target)return;const map={name:b.dataset.name,price:b.dataset.price?String(Number(b.dataset.price)/100):'',servings:b.dataset.servings,active:b.dataset.active,formula:b.dataset.formula,units:b.dataset.units,dailyUnits:b.dataset.dailyUnits,oil:b.dataset.oil,epa:b.dataset.epa,dha:b.dataset.dha};Object.entries(map).forEach(([n,v])=>{const input=get(target,n);if(input&&v!==undefined)input.value=v})}));root.querySelectorAll('[data-calculator]').forEach(form=>{form.addEventListener('reset',()=>{clear(form);form.querySelector('[data-results]').hidden=true});form.addEventListener('submit',event=>{event.preventDefault();clear(form);const out=form.querySelector('[data-results]'),type=form.dataset.calculator;if(type==='collagen'){const values=['a','b'].map(k=>{const s=form.querySelector(`[data-product="${k}"]`),price=num(get(s,'price').value),servings=num(get(s,'servings').value),active=num(get(s,'active').value);return{name:esc(get(s,'name').value.trim()||k.toUpperCase()),formula:get(s,'formula').value,price,servings,active,total:servings*active,day:price/servings,ten:price/(servings*active/10)}});if(values.some(v=>!ok(v.price)||!ok(v.servings)||!ok(v.active))){error(form,root.dataset.required);return}const note=values[0].formula!==values[1].formula?`<p>${root.dataset.formulaNote}</p>`:'';out.innerHTML=`<h3>Rezultat primerjave</h3><table><thead><tr><th>Merilo</th><th>${values[0].name}</th><th>${values[1].name}</th></tr></thead><tbody><tr><td>Kolagen v pakiranju</td><td>${fmt(values[0].total,1)} g</td><td>${fmt(values[1].total,1)} g</td></tr><tr><td>Cena na dan</td><td>${fmt(values[0].day)} €</td><td>${fmt(values[1].day)} €</td></tr><tr><td>Cena na 10 g</td><td>${fmt(values[0].ten)} €</td><td>${fmt(values[1].ten)} €</td></tr></tbody></table><p>${root.dataset.difference}: ${fmt(Math.abs(values[0].ten-values[1].ten))} € na 10 g. ${root.dataset.notQuality}</p>${note}`}if(type==='omega3'){const values=['a','b'].map(k=>{const s=form.querySelector(`[data-product="${k}"]`),price=num(get(s,'price').value),units=num(get(s,'units').value),dailyUnits=num(get(s,'dailyUnits').value),oil=num(get(s,'oil').value),epa=num(get(s,'epa').value),dha=num(get(s,'dha').value),daily=epa+dha,days=units/dailyUnits,pack=daily*days;return{name:esc(get(s,'name').value.trim()||k.toUpperCase()),price,units,dailyUnits,oil,epa,dha,daily,days,day:price/days,kilo:price/(pack/1000),concentration:ok(oil)?daily/oil*100:null}});if(values.some(v=>!ok(v.price)||!ok(v.units)||!ok(v.dailyUnits)||!ok(v.epa)||!ok(v.dha))){error(form,root.dataset.required);return}if(values.some(v=>ok(v.oil)&&v.daily>v.oil)){error(form,root.dataset.oilError);return}out.innerHTML=`<h3>Rezultat primerjave</h3><table><thead><tr><th>Merilo</th><th>${values[0].name}</th><th>${values[1].name}</th></tr></thead><tbody><tr><td>EPK + DHK na dan</td><td>${fmt(values[0].daily,0)} mg</td><td>${fmt(values[1].daily,0)} mg</td></tr><tr><td>Število dni</td><td>${fmt(values[0].days,1)}</td><td>${fmt(values[1].days,1)}</td></tr><tr><td>Cena na dan</td><td>${fmt(values[0].day)} €</td><td>${fmt(values[1].day)} €</td></tr><tr><td>Cena na 1000 mg</td><td>${fmt(values[0].kilo)} €</td><td>${fmt(values[1].kilo)} €</td></tr><tr><td>Delež v olju</td><td>${values[0].concentration===null?'—':fmt(values[0].concentration,1)+' %'}</td><td>${values[1].concentration===null?'—':fmt(values[1].concentration,1)+' %'}</td></tr></tbody></table><p>${root.dataset.difference}: ${fmt(Math.abs(values[0].kilo-values[1].kilo))} € na 1000 mg. ${root.dataset.notQuality}</p>`}if(type==='vitamin-product'||type==='vitamin-lab'){const amount=num(get(form,'amount').value),unit=get(form,'unit').value;if(!ok(amount)){error(form,root.dataset.required);return}if(type==='vitamin-product'){const ug=unit==='iu'?amount/40:amount,iu=unit==='iu'?amount:amount*40,nrv=ug/5*100;out.innerHTML=`<span class="hg__result">${fmt(iu,0)} IE = ${fmt(ug,2)} µg</span><p>${fmt(nrv,0)} % referenčne vrednosti hranila za označevanje. Odstotek ni osebno priporočilo.</p>`}else{const ng=unit==='ng'?amount:amount/2.5,nmol=unit==='ng'?amount*2.5:amount;out.innerHTML=`<span class="hg__result">${fmt(ng,2)} ng/mL = ${fmt(nmol,2)} nmol/L</span><p>Pretvorba spremeni samo mersko enoto. Rezultata ne razlaga kot diagnozo.</p>`}}out.hidden=false})})})})();

  } catch(e) { console.error(e); }
})();
})();
